import React from 'react';

interface DownloadAppPromptProps {
    title?: string;
    subtitle?: string;
    className?: string;
    titleClassName?: string;
}

const DownloadAppPrompt: React.FC<DownloadAppPromptProps> = ({
    title = 'MitiFresh🥭',
    subtitle = 'Transforming gardens into sustainable revenue streams.',
    className = '',
    titleClassName = 'text-3xl sm:text-4xl font-bold text-green-600 mb-6 whitespace-nowrap',
}) => {
    return (
        <div className={className}>
            <div
                className={titleClassName}
                style={{ fontFamily: 'Comic Sans MS, Comic Sans, cursive' }}
            >
                {title}
            </div>
            <p className="text-gray-600 text-sm">{subtitle}</p>

            <div className="flex flex-col sm:flex-row gap-2 mt-4">
                <a
                    href="https://apps.apple.com/us/app/mitifresh/id6742926258"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-2 bg-black text-white px-3 py-2 rounded-xl font-medium hover:bg-gray-800 transition-colors shadow-lg"
                >
                    <img src="/icons/apple.svg" alt="Apple" className="w-6 h-6 brightness-0 invert" />
                    Download iOS
                </a>
                <a
                    href="#waitlist"
                    className="inline-flex items-center justify-center gap-2 bg-[#3DDC84] text-gray-900 px-3 py-2 rounded-xl font-medium hover:bg-[#30c276] transition-colors shadow-lg"
                >
                    <img src="/icons/android.svg" alt="Android" className="w-6 h-6" />
                    Get Android
                </a>
            </div>
        </div>
    );
};

export default DownloadAppPrompt;
